import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-total-travaux',
    templateUrl: './total-travaux.component.html',
    styleUrls: ['./total-travaux.component.scss']
})
export class TotalTravauxComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }

}
